import { render } from "./CreateAndUpdate.vue?vue&type=template&id=4dc41629&scoped=true"
import script from "./CreateAndUpdate.vue?vue&type=script&lang=js"
export * from "./CreateAndUpdate.vue?vue&type=script&lang=js"

import "./CreateAndUpdate.vue?vue&type=style&index=0&id=4dc41629&scoped=true&lang=css"
import "./CreateAndUpdate.vue?vue&type=style&index=1&id=4dc41629&lang=css"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc41629"]])

export default __exports__